<template>
  <div class="contextual-menu">
    <v-menu offset-y bottom left minWidth="180" :data-testid="tid">
      <template v-slot:activator="{ on, value }">
        <div class="contextual-menu__trigger" v-on="on">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="onClickDots(!value)">
                <v-icon
                  size="20"
                  :color="
                    dotsColor === 'white' ? 'white' : 'blue-grey darken-2'
                  "
                  >mdi-dots-vertical</v-icon
                >
              </v-btn>
            </template>
            {{ $t('common.options_other') }}
          </v-tooltip>
        </div>
      </template>
      <v-list nav dense>
        <template v-for="(option, index) in options">
          <v-divider v-if="option.divider" class="pa-0 ma-0" :key="index" />
          <v-list-item
            v-else
            :key="option.id"
            :data-testid="option.tid"
            @click="optionClicked(option.id)"
          >
            <v-list-item-icon class="me-1">
              <v-icon
                v-if="option.icon"
                :color="
                  option.iconColor ? option.iconColor : 'blue-grey darken-2'
                "
                >{{ option.icon }}</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="blue-grey--text text--darken-2">{{
                option.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'ContextualMenu',

  props: {
    options: {
      type: Array,
      required: true,
    },
    dotsColor: {
      type: String,
      required: false,
    },
    tid: {
      type: String,
      required: false,
      default: 'contextual-menu',
    },
  },

  methods: {
    onClickDots(isOpen) {
      if (isOpen) this.$emit('openMenu')
    },
    optionClicked: function(id) {
      this.$emit('optionClicked', id)
    },
  },
}
</script>
